var _path, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAddLink = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3894 9.80535C7.73526 10.2677 8.17652 10.6503 8.68324 10.9272C9.18996 11.204 9.7503 11.3686 10.3262 11.4099C10.9022 11.4511 11.4803 11.368 12.0213 11.1662C12.5623 10.9644 13.0535 10.6486 13.4618 10.2402L15.8778 7.82419C16.6113 7.06473 17.0172 6.04757 17.008 4.99176C16.9988 3.93596 16.5753 2.926 15.8288 2.17941C15.0822 1.43282 14.0722 1.00933 13.0164 1.00015C11.9606 0.990978 10.9434 1.39685 10.184 2.13036L8.79877 3.50751",
    stroke: "#7D86A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6107 8.19477C10.2648 7.7324 9.82358 7.34981 9.31686 7.07297C8.81014 6.79612 8.24981 6.63149 7.67387 6.59024C7.09793 6.549 6.51985 6.6321 5.97885 6.8339C5.43785 7.03571 4.94657 7.35151 4.53835 7.75988L2.1223 10.1759C1.3888 10.9354 0.982921 11.9526 0.992096 13.0084C1.00127 14.0642 1.42476 15.0741 2.17135 15.8207C2.91795 16.5673 3.92791 16.9908 4.98371 17C6.03951 17.0091 7.05668 16.6033 7.81613 15.8698L9.19328 14.4926",
    stroke: "#7D86A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddLink, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/add_link.674e5b95.svg";
export { ForwardRef as ReactComponent };